<!-- eslint-disable max-len -->
    <template>
  <div class="py-1">
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="importModal"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
          z-40
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-3/4 md:w-1/3 max-h-95/100">
          <div class="flex flex-col items-start p-5">
            <section>
              <h3 class="text-lg font-semibold">Import Users</h3>
            </section>
            <section class="flex items-center w-full">
              <textarea
                class="w-full border border-gray-500 rounded-md p-2 focus:outline-none focus:border-gray-600"
                name=""
                id=""
                cols="30"
                rows="10"
                v-model="userNames"
              ></textarea>
            </section>
            <section class="mt-10 w-full flex justify-center">
              <div class="mr-5">
                <button class="btn btn-primary btn-outline" @click="callback()">
                  cancel
                </button>
              </div>
              <div class="">
                <button class="btn btn-primary" @click="addUsersToSegment">
                  Import
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
    <ResponseMessage
      :openPopup="openPopup"
      :callback="handleMessagePopup"
      :mssg="mssg"
      :failedDmlist="failedSignlist"
    />
  </div>
</template>

<script>
import ResponseMessage from '../Common/ResponseMessage.vue';
import userInfo from '@/services/userInfo';
import utils from '@/services/utils';

export default {
  name: 'ImportUsersModal',
  layout: 'admin',
  components: { ResponseMessage },
  data() {
    return {
      segmentId: '',
      userNames: '',
      mssg: 'Successfully added"',
      openPopup: false,
      failedSignlist: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  props: [
    'importModal',
    'callback',
    'enrolledStudents',
    'enrolled',
    'courseId',
  ],
  methods: {
    handleMessagePopup() {
      this.openPopup = !this.openPopup;
    },
    async addUsersToSegment() {
      try {
        const userNamesArray = this.userNames
          .split(/\r?\n/)
          .filter((el) => el !== '');
        console.log(userNamesArray);
        this.$store.commit('toggleLoading', true);
        const res = await userInfo
          .importUsername({
            userNamesArray,
            courseId: this.courseId,
            creatorId: this.user.uid,
          });
        this.callback();
        this.userNames = '';
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, res.message);
      } catch (error) {
        this.$store.commit('toggleLoading', false);
        console.log('username import in course error', error);
        utils.setStatusMsg(this, error?.response?.data?.message);
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
